import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import './styles.scss'
import TextInput from 'components/TextField'
import SelectAddress from 'components/Select'
import RadioInput from 'features/Shop/components/PaymentMethod'
import { options } from 'data/shop/payment'
import jsonData from 'data/shop/address'
import { validateField, validateAddress } from 'utils/validationForm'

const FormCheckout = ({ setValidForm, setFormDataValue, showErrors }) => {
  const [data, setData] = useState([])
  const [selectedProvince, setSelectedProvince] = useState('')
  const [selectedDistrict, setSelectedDistrict] = useState('')
  const [selectedWard, setSelectedWard] = useState('')

  const [formData, setFormData] = useState({
    email: '',
    fullName: '',
    phoneNumber: '',
    streetAddress: '',
    selectedPaymentMethod: 'Cash on Delivery (COD)',
    address: {}
  })

  const [errors, setErrors] = useState({
    email: '',
    fullName: '',
    phoneNumber: '',
    streetAddress: '',
    address: ''
  })

  useEffect(() => {
    setData(jsonData)
  }, [])

  const handleInputChange = (name, newValue) => {
    const updatedFormData = { ...formData, [name]: newValue }
    const newErrors = { ...errors, [name]: validateField(name, newValue) }
    setFormData(updatedFormData)
    setErrors(newErrors)

    setFormDataValue(updatedFormData)
  }

  useEffect(() => {
    const selectedAddress = {
      province: selectedProvince,
      district: selectedDistrict,
      ward: selectedWard
    }

    const newErrors = {}
    Object.keys(formData).forEach((name) => {
      newErrors[name] = validateField(name, formData[name])
    })

    newErrors.address = validateAddress(
      selectedAddress.province,
      selectedAddress.district,
      selectedAddress.ward
    )

    // console.log(newErrors)

    setErrors(newErrors)

    const isValid = !Object.values(newErrors).some((error) => !!error)
    setValidForm(isValid)

    setFormDataValue({
      ...formData,
      address: {
        provinces: data.find((province) => province.Id === selectedProvince)?.Name,
        districts: data
          .find((province) => province.Id === selectedProvince)
          ?.Districts.find((district) => district.Id === selectedDistrict)?.Name,
        wards: data
          .find((province) => province.Id === selectedProvince)
          ?.Districts.find((district) => district.Id === selectedDistrict)
          ?.Wards.find((ward) => ward.Id === selectedWard)?.Name
      }
    })
  }, [
    formData,
    selectedProvince,
    selectedDistrict,
    selectedWard,
    setValidForm,
    setFormDataValue,
    data
  ])

  const handleProvinceChange = (value) => {
    setSelectedProvince(value)
    setSelectedDistrict('')
    setSelectedWard('')
  }

  // Define provinces, districts, and wards variables here
  const provinces = data.map((province) => ({
    label: province.Name,
    value: province.Id
  }))

  const selectedProvinceData = data.find((province) => province.Id === selectedProvince)
  const districts =
    selectedProvinceData?.Districts?.map((district) => ({
      label: district.Name,
      value: district.Id
    })) || []

  const selectedDistrictData = selectedProvinceData?.Districts.find(
    (district) => district.Id === selectedDistrict
  )
  const wards =
    selectedDistrictData?.Wards?.map((ward) => ({
      label: ward.Name,
      value: ward.Id
    })) || []

  return (
    <div className="form-checkout-left">
      <form className="form-input-select">
        <TextInput
          error={showErrors ? errors.email : ''}
          placeholder="Email"
          type="email"
          name="email"
          value={formData.email}
          onChange={(newValue) => handleInputChange('email', newValue)}
        />
        <TextInput
          error={showErrors ? errors.fullName : ''}
          placeholder="Full Name"
          type="text"
          name="fullName"
          value={formData.fullName}
          onChange={(newValue) => handleInputChange('fullName', newValue)}
        />
        <TextInput
          error={showErrors ? errors.phoneNumber : ''}
          placeholder="Phone Number"
          type="text"
          name="phoneNumber"
          value={formData.phoneNumber}
          onChange={(newValue) => handleInputChange('phoneNumber', newValue)}
        />
        <div className="form-select-address-error">
          <div className="form-select-address">
            <SelectAddress
              tagname="Province"
              options={provinces}
              value={selectedProvince}
              onChange={handleProvinceChange}
            />
            <SelectAddress
              tagname="District"
              options={districts}
              disabled={districts.length === 0}
              value={selectedDistrict}
              onChange={(value) => setSelectedDistrict(value)}
            />
            <SelectAddress
              tagname="Ward"
              options={wards}
              disabled={wards.length === 0}
              value={selectedWard}
              onChange={(value) => setSelectedWard(value)}
            />
          </div>

          <div
            className={`${errors.address && showErrors ? 'active-error' : 'frame-error-address '}`}
          >
            <p>{showErrors ? errors.address : ''}</p>
          </div>
        </div>
        <TextInput
          error={showErrors ? errors.streetAddress : ''}
          placeholder="House number, Street name"
          type="text"
          name="streetAddress"
          value={formData.streetAddress}
          onChange={(newValue) => handleInputChange('streetAddress', newValue)}
        />
      </form>
      <div className="frame-payment-methods">
        <h5>Payment methods</h5>
        <div>
          <RadioInput
            options={options}
            name="selectedPaymentMethod"
            onChange={(newValue) => handleInputChange('selectedPaymentMethod', newValue)}
          />
        </div>
      </div>
    </div>
  )
}

FormCheckout.propTypes = {
  setValidForm: PropTypes.func,
  setFormDataValue: PropTypes.func,
  showErrors: PropTypes.bool
}

export default FormCheckout
